import React, { useState, useEffect, useRef } from "react";
import {
  InteractiveMap,
  NavigationControl,
  Marker,
  Layer,
  Source,
} from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import axios from "axios";

const MAPBOX_TOKEN =
  "pk.eyJ1Ijoicm9iZXJ0a3BtIiwiYSI6ImNtNml6aWs1dzA0dWwybHM4aGd2NWl2NmgifQ.AOsGlqDkaT6FSAMor3Grow";
const API_ENDPOINT =
  "https://7gyutppcwl.execute-api.us-east-1.amazonaws.com/Prod/liveTracking/updateUnits";
const TrackingMap = ({
  vehicles,
  vehicleImages,
  truck,
  allUpdatedVehicleIds,
  selectedVehicleIds,
  minimapVehicle,
}) => {
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [updateUnits, setAllUpdatedVehicleIds] = useState(null);
  const [routeGeoJSON, setRouteGeoJSON] = useState(null);
  const [routeGeoJSONs, setRouteGeoJSONs] = useState({});
  const showLine = vehicles?.length === 1;
  const [miniMapViewport, setMiniMapViewport] = useState({
    latitude: -1.286389, // Nairobi, Kenya
    longitude: 36.817223, // Nairobi, Kenya
    zoom: 3,
    width: "100%",
    height: "100%",
  });

  const [miniMapSize, setMiniMapSize] = useState({ width: 400, height: 300 });

  const [viewport, setViewport] = useState({
    latitude: -1.28333, // Nairobi, Kenya
    longitude: 36.81667, // Nairobi, Kenya
    zoom: 3,
    width: "100%",
    height: "100%",
  });

  // useEffect(() => {

  //   setAllUpdatedVehicleIds(vehicles);
  //   fetchAllRoutes(vehicles);
  //   if (vehicles?.length === 1) {
  //     setViewport({
  //       latitude:
  //         vehicles?.reduce((sum, item) => sum + item.latitude, 0) /
  //         vehicles?.length,
  //       longitude:
  //         vehicles?.reduce((sum, item) => sum + item.longitude, 0) /
  //         vehicles?.length,
  //       zoom: 10,
  //       width: "100%",
  //       height: "100vh",
  //     });
  //   } else {
  //     setViewport({
  //       latitude: -1.286389, // Nairobi, Kenya
  //       longitude: 36.817223, // Nairobi, Kenya
  //       zoom: 3,
  //       width: "100%",
  //       height: "100%",
  //     });
  //   }
  //   // fetchRoute(vehicles);
  // }, [vehicles]);

  const previousVehiclesRef = useRef(0); // ✅

  useEffect(() => {
    // Only trigger if vehicle count changes (initial load or major change)
    if (vehicles.length !== previousVehiclesRef.current) {
      previousVehiclesRef.current = vehicles.length;

      setAllUpdatedVehicleIds(vehicles);
      fetchAllRoutes(vehicles);

      if (vehicles.length === 1) {
        const avgLat =
          vehicles?.reduce((sum, item) => sum + item.latitude, 0) /
          vehicles?.length;
        const avgLng =
          vehicles?.reduce((sum, item) => sum + item.longitude, 0) /
          vehicles?.length;

        setViewport((prev) => ({
          ...prev,
          latitude: avgLat,
          longitude: avgLng,
          zoom: 10,
        }));
      } else {
        setViewport((prev) => ({
          ...prev,
          latitude: -1.286389,
          longitude: 36.817223,
          zoom: 3,
        }));
      }
    }
  }, [vehicles]);

  const fetchAllRoutes = async (vehicles) => {
    const routes = {};

    for (const vehicle of vehicles) {
      const { endlongitude, endlatitude, latitude, longitude, id } = vehicle;
      const url = `https://api.mapbox.com/directions/v5/mapbox/driving/${longitude},${latitude};${endlongitude},${endlatitude}?geometries=geojson&access_token=${MAPBOX_TOKEN}`;

      try {
        const response = await fetch(url);
        const data = await response.json();

        if (data.routes && data.routes.length > 0) {
          routes[id] = {
            type: "Feature",
            geometry: data.routes[0].geometry,
          };
        }
      } catch (error) {
        console.error(`Error fetching route for vehicle ${id}:`, error);
      }
    }

    setRouteGeoJSONs(routes);
  };

  // const fetchRoute = async (location) => {
  //   const getLocation = location.reduce((acc, item) => {
  //     return { ...acc, ...item };
  //   }, {});
  //   console.log("getLocation-->", getLocation);
  //   const { endlongitude, endlatitude, latitude, longitude } = getLocation;
  //   console.log("location-->", location);

  //   const url = `https://api.mapbox.com/directions/v5/mapbox/driving/${longitude},${latitude};${endlongitude},${endlatitude}?geometries=geojson&access_token=${MAPBOX_TOKEN}`;

  //   console.log("Fetching route from Mapbox API:", url);

  //   try {
  //     const response = await fetch(url);
  //     const data = await response.json();
  //     console.log("Route API Response:", data);

  //     if (data.routes && data.routes.length > 0) {
  //       setRouteGeoJSON({
  //         type: "Feature",
  //         geometry: data.routes[0].geometry,
  //       });
  //     } else {
  //       console.error("No route found!");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching route:", error);
  //   }
  // };

  // const fetchAllupdateVehicle = async () => {
  //   try {
  //     const token =
  //       "2f98a65e766e3cbf17c9c7c52e238e58CA4C183D189FC3B4E6437699904FFDAD66487A5E";
  //     const unitIds = vehicles.map((vehicle) => vehicle.id);

  //     const allData = await axios.post(API_ENDPOINT, {
  //       token,
  //       unitIds: allUpdatedVehicleIds,
  //     });
  //     console.log("API Responses:", allData);
  //     const updated = vehicles.map((vehicle) => {
  //       const tripsInfo = allData
  //         .find((item) => item[vehicle.id])
  //         ?.[vehicle.id]?.find((item) => item.trips)?.trips;
  //       return {
  //         ...vehicle,
  //         latitude: tripsInfo?.to?.y ?? vehicle.latitude,
  //         longitude: tripsInfo?.to?.x ?? vehicle.longitude,
  //         endlatitude: tripsInfo?.from?.y ?? vehicle.latitude,
  //         endlongitude: tripsInfo?.from?.x ?? vehicle.longitude,
  //       };
  //     });
  //     if (vehicles?.length === 1) {
  //       fetchRoute(updated);
  //       setViewport({
  //         latitude:
  //           vehicles?.reduce((sum, item) => sum + item.latitude, 0) /
  //           vehicles?.length,
  //         longitude:
  //           vehicles?.reduce((sum, item) => sum + item.longitude, 0) /
  //           vehicles?.length,
  //         zoom: 10,
  //         width: "100%",
  //         height: "100vh",
  //       });
  //     } else {
  //       fetchRoute([]);
  //       setViewport({
  //         latitude: -1.286389, // Nairobi, Kenya
  //         longitude: 36.817223, // Nairobi, Kenya
  //         zoom: 5,
  //         width: "100%",
  //         height: "100%",
  //       });
  //     }

  //     console.log("Updated Vehicles:", updated);
  //     setAllUpdatedVehicleIds(updated);

  //     // Adjust viewport
  //     // updateViewport(updated);
  //   } catch (error) {
  //     console.error("Error updating units:", error);
  //   }
  // };

  // Helper function to split array into chunks

  // useEffect(() => {
  //   fetchAllupdateVehicle();
  // }, [vehicles]);
  const lineGeoJSON = {
    type: "Feature",
    geometry: {
      type: "LineString",
      coordinates: [
        [parseFloat(updateUnits?.longitude), parseFloat(updateUnits?.latitude)],
        [
          parseFloat(updateUnits?.endlongitude),
          parseFloat(updateUnits?.endlatitude),
        ],
      ],
    },
  };

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     fetchAllupdateVehicle();
  //   }, 7000); // Calls the function every 3 seconds

  //   return () => clearInterval(interval); // Cleanup on unmount
  // }, []);

  const [miniMapPosition, setMiniMapPosition] = useState({ top: 20, left: 20 });
  const [isDragging, setIsDragging] = useState(false);
  const [isResizing, setIsResizing] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const [resizeStart, setResizeStart] = useState({
    x: 0,
    y: 0,
    width: 400,
    height: 300,
  });

  const handleDragStart = (e) => {
    if (e.target.classList.contains("minimap-header")) {
      setIsDragging(true);
      setDragStart({
        x: e.clientX,
        y: e.clientY,
        startTop: miniMapPosition.top,
        startLeft: miniMapPosition.left,
      });
    }
  };

  const handleResizeStart = (e) => {
    setIsResizing(true);
    setResizeStart({ x: e.clientX, y: e.clientY, ...miniMapSize });
  };

  const handleMouseMove = (e) => {
    if (isDragging) {
      const deltaX = e.clientX - dragStart.x;
      const deltaY = e.clientY - dragStart.y;
      const newTop = dragStart.startTop + deltaY;
      const newLeft = dragStart.startLeft + deltaX;

      setMiniMapPosition({ top: newTop, left: newLeft });
    }

    if (isResizing) {
      const deltaX = e.clientX - resizeStart.x;
      const deltaY = e.clientY - resizeStart.y;
      const newWidth = Math.max(200, resizeStart.width + deltaX);
      const newHeight = Math.max(150, resizeStart.height + deltaY);

      setMiniMapSize({
        width: newWidth,
        height: newHeight,
      });

      // Update the miniMapViewport dimensions
      setMiniMapViewport((prev) => ({
        ...prev,
        width: `${newWidth}px`,
        height: `${newHeight}px`,
      }));
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    setIsResizing(false);
  };

  // Attach global event listeners
  useEffect(() => {
    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isDragging, isResizing]);

  useEffect(() => {
    if (minimapVehicle) {
      console.log("23-->", updateUnits);
      const vehicle = updateUnits?.find((v) => v.id === minimapVehicle);
      console.log("vehicle567-->", vehicle);
      setSelectedVehicle(vehicle);
      setMiniMapViewport({
        latitude: vehicle?.latitude,
        longitude: vehicle?.longitude,
        zoom: 15,
        width: "100%",
        height: "100%",
      });
    }
  }, [minimapVehicle, updateUnits]);

  return (
    <div style={{ position: "relative", width: "100%", height: "100vh" }}>
      <InteractiveMap
        {...viewport}
        onViewportChange={(newViewport) => setViewport(newViewport)}
        mapStyle="mapbox://styles/mapbox/streets-v11"
        mapboxApiAccessToken={MAPBOX_TOKEN}
        scrollZoom={true}
        dragPan={true}
        touchZoom={true}
      >
        {/* Loop through each vehicle and place it on the map */}
        {updateUnits?.map((vehicle) => (
          <Marker
            key={vehicle.id}
            latitude={vehicle.latitude}
            longitude={vehicle.longitude}
          >
            <img
              src={vehicleImages[vehicle.id] || truck}
              onError={(e) => (e.target.src = truck)}
              width="40"
              height="40"
              style={{ borderRadius: "50%", cursor: "pointer" }}
              onClick={() => {
                setSelectedVehicle(vehicle);
                setMiniMapViewport({
                  latitude: vehicle.latitude,
                  longitude: vehicle.longitude,
                  zoom: 15,
                  width: "100%",
                  height: "100%",
                });
              }}
            />
          </Marker>
        ))}
        {showLine && (
          <Source id="route" type="geojson" data={lineGeoJSON}>
            <Layer
              id="route"
              type="line"
              paint={{
                "line-color": "green",
                "line-width": 4,
              }}
            />
          </Source>
        )}
        {selectedVehicleIds?.length > 0 && (
          <>
            {Object.entries(routeGeoJSONs).map(([vehicleId, geoJSON]) => (
              <Source
                key={vehicleId}
                id={`route-${vehicleId}`}
                type="geojson"
                data={geoJSON}
              >
                <Layer
                  id={`route-line-${vehicleId}`}
                  type="line"
                  paint={{
                    "line-color": "green",
                    "line-width": 4,
                  }}
                />
              </Source>
            ))}
          </>
        )}

        {routeGeoJSON && (
          <Source id="route" type="geojson" data={routeGeoJSON}>
            <Layer
              id="route-line"
              type="line"
              paint={{
                "line-color": "green",
                "line-width": 4,
              }}
            />
          </Source>
        )}
      </InteractiveMap>

      {/* Mini Map for selected vehicle */}
      {selectedVehicle && (
        <div
          style={{
            position: "absolute",
            top: miniMapPosition.top,
            left: miniMapPosition.left,
            width: miniMapSize.width,
            height: miniMapSize.height,
            background: "white",
            borderRadius: "10px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
            overflow: "hidden",
            zIndex: 1000,
            display: "flex",
            flexDirection: "column",
            cursor: isDragging ? "move" : "default",
          }}
          onMouseDown={(e) => handleDragStart(e)}
        >
          {/* Header */}
          <div
            className="minimap-header"
            style={{
              background: "#333",
              color: "white",
              padding: "8px 10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              cursor: "grab",
            }}
            onMouseDown={handleDragStart}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <img
                src={vehicleImages[selectedVehicle.id] || truck}
                onError={(e) => (e.target.src = truck)}
                width="20"
                height="20"
              />
              <span
                style={{ fontSize: "14px", fontWeight: "bold", color: "white" }}
              >
                {/* {selectedVehicle?.vehicleNumber} */}
                {/* TBA/GCXU639930/7 */}
                {selectedVehicle.name}
              </span>
            </div>
            <button
              onClick={() => setSelectedVehicle(null)}
              style={{
                background: "transparent",
                color: "white",
                border: "none",
                fontSize: "16px",
                cursor: "pointer",
              }}
            >
              ✖
            </button>
          </div>

          {/* Optional Speed Display */}
          <div
            style={{
              fontSize: "15px",
              padding: "4px 10px",
              color: "#363636",
              textAlign: "center",
            }}
          >
            {/* Km: {selectedVehicle?.speed || 0} km/h */}
            Km: {selectedVehicle.km || 0} km/h
          </div>

          {/* Map Container */}
          <div style={{ flex: 1 }}>
            <InteractiveMap
              {...miniMapViewport}
              onViewportChange={(newViewport) =>
                setMiniMapViewport(newViewport)
              }
              mapStyle="mapbox://styles/mapbox/streets-v11"
              mapboxApiAccessToken={MAPBOX_TOKEN}
              scrollZoom={true}
              dragPan={true}
              touchZoom={true}
            >
              <Marker
                latitude={selectedVehicle.latitude}
                longitude={selectedVehicle.longitude}
              >
                <img
                  src={vehicleImages[selectedVehicle.id] || truck}
                  onError={(e) => (e.target.src = truck)}
                  width="30"
                  height="30"
                  style={{ borderRadius: "50%" }}
                />
              </Marker>

              {selectedVehicleIds?.length > 0 && (
                <>
                  {Object.entries(routeGeoJSONs).map(([vehicleId, geoJSON]) => (
                    <Source
                      key={vehicleId}
                      id={`route-${vehicleId}`}
                      type="geojson"
                      data={geoJSON}
                    >
                      <Layer
                        id={`route-line-${vehicleId}`}
                        type="line"
                        paint={{
                          "line-color": "green",
                          "line-width": 4,
                        }}
                      />
                    </Source>
                  ))}
                </>
              )}
            </InteractiveMap>
          </div>
          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              width: "20px",
              height: "20px",
              background: "rgba(0, 0, 0, 0.2)",
              cursor: "nwse-resize",
            }}
            onMouseDown={(e) => handleResizeStart(e)}
          ></div>
        </div>
      )}
    </div>
  );
};

export default TrackingMap;
